import { render, staticRenderFns } from "./AdvantageVideo.vue?vue&type=template&id=3b33297b&scoped=true&"
import script from "./AdvantageVideo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdvantageVideo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdvantageVideo.vue?vue&type=style&index=0&id=3b33297b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33297b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b33297b')) {
      api.createRecord('3b33297b', component.options)
    } else {
      api.reload('3b33297b', component.options)
    }
    module.hot.accept("./AdvantageVideo.vue?vue&type=template&id=3b33297b&scoped=true&", function () {
      api.rerender('3b33297b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuAdvantages/components/AdvantageVideo.vue"
export default component.exports